import { LoadingSpinner } from "MVVM/Components/Lottie";
import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

const NoResults = ({
  loading,
  isMatchHistoryWidget = false,
}: {
  loading: boolean;
  isMatchHistoryWidget?: boolean;
}) => (
  <NoResultsContainer $isMatchHistoryWidget={isMatchHistoryWidget}>
    {loading ? (
      <Flex mt={20} alignItems="center" data-testid="loading-indicator">
        <LoadingSpinner height={24} width={24} />
      </Flex>
    ) : (
      <>
        <Text
          color="chalkAlpha40"
          fontSize={18}
          fontWeight={500}
          mt={isMatchHistoryWidget ? [60, 15, 20] : [60, 60, 20]}
        >
          No Results Found
        </Text>
        <Text color="chalkAlpha40" fontSize={12} fontWeight={500}>
          Try searching for a different username
        </Text>
      </>
    )}
  </NoResultsContainer>
);

const NoResultsContainer = styled(Flex)<{ $isMatchHistoryWidget: boolean }>`
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding-bottom: ${({ $isMatchHistoryWidget }) =>
    $isMatchHistoryWidget ? "10px" : "30px"};
`;

export { NoResults };
